import script from "./OAdicionarAtributo.vue?vue&type=script&lang=ts&setup=true"
export * from "./OAdicionarAtributo.vue?vue&type=script&lang=ts&setup=true"

import "./OAdicionarAtributo.vue?vue&type=style&index=0&id=01357f17&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01357f17"]])

export default __exports__